import React from 'react';
import withStyles from 'react-jss';
import { withRouter } from 'react-router-dom';
import User from '../../views/User/User';
import { useEventLogs, useUser } from '../../services/Firestore/Resources';
import EventList from '../../views/Events/EventList';

const styles = {
  topBar: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
  },
  buttons: {
    justifySelf: 'self-end',
    margin: 10,
  },
};

const UsersPage = ({ userId }) => {
  const [user, userLoading] = useUser(userId);
  const [events, eventsLoading] = useEventLogs({
    where: [{ field: 'user.id', op: '==', value: userId }],
    orderBy: [['timestamp', 'desc']],
    limit: 250,
  });
  if (eventsLoading || userLoading) {
    return <p>Loading user</p>;
  }
  return (
    <>
      <User user={user} />
      <EventList events={events} />
    </>
  );
};

export default withRouter(withStyles(styles)(UsersPage));
